import React from "react";

import { useTranslation } from "react-i18next";

import { Bet } from "@models";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { hasActiveEvents } from "@utils/my-bets/helpers";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";
import { ReuseBetSlipStore } from "@state/stores/my-bets/ReuseBetSlipStore";

export const BetDetailsBetReuseButton = (props: {
	store: BetDetailsModalStore | BetSlipReceiptModalStore;
	bet: Bet;
}) => {
	const { t } = useTranslation("mybets");

	let reuseStore: ReuseBetSlipStore;

	if (props.store instanceof BetSlipReceiptModalStore) {
		reuseStore = props.store.reuseBetSlipStore;
	} else {
		reuseStore = props.store.myBetsStore.reuseBetSlipStore;
	}

	if (reuseStore == null) {
		return null;
	}

	if (!hasActiveEvents(props.bet)) {
		return null;
	}

	return (
		<button
			className="bet__btn btn btn--med btn--block btn--primary--inverted btn--icon btn--animate-rotate"
			type="button"
			onClick={() => {
				reuseStore.openReuseBetSlipModalBetDetails(props.bet);
				props.store.onReuseOpen();
			}}
		>
			<i className="u-icon u-icon--sml u-icon--refresh"></i>
			<span>{t<string>("REUSE.BUTTON_LABEL")}</span>
		</button>
	);
};
